import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface NameProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Name: React.FC<NameProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [name, set_name] = useBudgetConstructionField<string>(
        propertyGuid,
        (b) => b.values?.['Electrical (Largest Subcontractor or Supplier)']?.['Name'] ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Electrical (Largest Subcontractor or Supplier)': { ...b.values?.['Electrical (Largest Subcontractor or Supplier)'], 'Name': v } } })
    );
    const label = 'Name';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={name}
                />
            ) : (
                <TextBox
                    value={name}
                    onChange={(value) => set_name(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
